export default __webpack_public_path__ + "static/media/Blooded Girdle of the Four Winds.51cfb083.jpg";